import styled from 'styled-components';
import { rem } from 'polished';
import { VehicleDetailsHeadingInformationStyled } from '../VehicleDetailsHeadingInformationStyled';
export const VehicleDetailsHeadingInformationStyledOVGB = styled(VehicleDetailsHeadingInformationStyled)`
    .information > .titleWithBenefits > .show-characteristics-button {
        position: relative;
        width: fit-content;
        .link {
            text-transform: uppercase;
            color: ${({ theme }) => theme.colors.black};
            font-size: ${rem('14px')};
        }

        .icon-wrapper {
            margin-left: ${rem('10px')};

            svg {
                width: fit-content;

                path {
                    fill: ${({ theme }) => theme.colors.black} !important;
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }
            }
        }

        &:hover {
            .icon-wrapper {
                svg path {
                    fill: ${({ theme }) => theme.colors.black} !important;
                    stroke: ${({ theme }) => theme.colors.black} !important;
                }
            }
        }
    }
`;
